import { render, staticRenderFns } from "./AirPortTicket.vue?vue&type=template&id=2cfd7808&scoped=true"
import script from "./AirPortTicket.vue?vue&type=script&lang=ts"
export * from "./AirPortTicket.vue?vue&type=script&lang=ts"
import style0 from "./AirPortTicket.vue?vue&type=style&index=0&id=2cfd7808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd7808",
  null
  
)

export default component.exports